import React from 'react';
import { Coins } from 'lucide-react';

const Title = ({ count }) => {
  return (
    <div className="bg-blueLight flex flex-row justify-between items-center p-4" style={{ borderRadius: '12px' }}>
      <div className="flex items-center gap-3">
        <Coins className="text-tealBase" size={20} strokeWidth={1.75} />
        <span className="text-blueDarker text-xl font-semibold">
          Fundos de Investimento <span className="font-normal">({count} ativos)</span>
        </span>
      </div>

      <div className="flex items-center gap-5">
        <Legend color="#55A32A" label="Cliente + Modelo" />
        <Legend color="#622CAC" label="Apenas Modelo" />
        <Legend color="#B37133" label="Apenas Cliente" />
      </div>
    </div>
  );
};

const Legend = ({ color, label }) => (
  <div className="flex items-center gap-2">
    <span className="flex-none block rounded" style={{ backgroundColor: color, width: '12px', height: '12px' }} />
    <span className="text-base text-blueDarker">{label}</span>
  </div>
);

export default Title;
